"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _Row = _interopRequireDefault(require("../baseComponents/Row"));
var _Col = _interopRequireDefault(require("../baseComponents/Col"));
var _excluded = ["tableContent", "style", "textAlign", "className", "sortable", "headerContent", "disabled", "sort"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var Table = function Table(props) {
  var tableContent = props.tableContent,
    style = props.style,
    textAlign = props.textAlign,
    className = props.className,
    sortable = props.sortable,
    headerContent = props.headerContent,
    disabled = props.disabled,
    sort = props.sort,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = (0, _classnames["default"])("table", className);
  var xs = 12 / headerContent.length;
  function selectColumn(event) {
    if (sortable) {
      var columns = document.getElementsByClassName("first-row");
      for (var i = 0; i < columns.length; i++) {
        columns[i].className = columns[i].className.replace(" selected", "");
      }
      var nextRow = document.getElementsByClassName("next-row");
      for (var _i = 0; _i < nextRow.length; _i++) {
        nextRow[_i].className = nextRow[_i].className.replace(" selected", "");
      }
      event.currentTarget.className += " selected";
      var cols = document.getElementsByClassName("col" + event.currentTarget.id);
      for (var _i2 = 0; _i2 < cols.length; _i2++) {
        cols[_i2].classList.add("selected");
      }
    }
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "table-component"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    style: style
  }, headerContent.length > 0 && /*#__PURE__*/_react["default"].createElement(_Row["default"], {
    center: "xs",
    middle: "xs",
    className: "headerRow"
  }, headerContent.map(function (item, key) {
    return /*#__PURE__*/_react["default"].createElement(_Col["default"], _extends({
      xs: xs,
      className: (0, _classnames["default"])("first-row", sortable ? "sortable" : "", textAlign),
      onClick: function onClick(event) {
        return selectColumn(event);
      }
    }, props.onClick, {
      id: key,
      key: key
    }), sortable && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("icon-right", sort)
    }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-arrow"
    })), item, sortable && /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("icon-left", sort)
    }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
      name: "micro-glyph-arrow"
    })));
  })), tableContent != null && tableContent.map(function (dataItem, key) {
    return /*#__PURE__*/_react["default"].createElement(_Row["default"], {
      center: "xs",
      middle: "xs",
      key: key,
      className: "bodyRow"
    }, dataItem.map(function (item, index) {
      return /*#__PURE__*/_react["default"].createElement(_Col["default"], {
        xs: xs,
        key: index,
        className: (0, _classnames["default"])("next-row", textAlign, disabled && "disabled", "col".concat(index))
      }, item);
    }));
  })));
};
Table.propTypes = {
  tableContent: _propTypes["default"].array,
  headerContent: _propTypes["default"].array,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  textAlign: _propTypes["default"].oneOf(["", "text-align-left", "text-align-right"]),
  sortable: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  sort: _propTypes["default"].oneOf(["asc", "desc"])
};
Table.defaultProps = {
  tableContent: null,
  headerContent: [],
  className: "",
  style: {},
  textAlign: "",
  sortable: false,
  disabled: false,
  onClick: function onClick() {},
  sort: "desc"
};
var _default = exports["default"] = Table;